import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("supplychain") !== null && localStorage.getItem("supplychain") !== undefined && localStorage.getItem("supplychain") !== "") {

    data = JSON.parse(localStorage.getItem("supplychain"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getsupplychain: (state, action) => {
            localStorage.setItem("supplychain", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, getsupplychain } = Insider.actions;
export default Insider.reducer;